<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Datos Maestros"
          directory="Administrar Firmas"
          :icon="'grid'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            Añadir
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <manage-signatures-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
      modalTitle="Añadir Firmas a Documentos"
      editModalTitle="Editar Firmas"
      :disablecode="disablecode"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      modal-id="modal-delete"
      @confirmed="deleteData"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este registro?"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "manage-signatures-table",
      rowData: {},
      disablecode: false,
      options: {
        name: "",
        url: `${actions.MASTER_DATA}/manage-signatures/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "manage-signatures-modal",
            modalId: "modal-add-edit",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "modal-delete",
          },
        ],
        filters: [
          {
            title: "Estado",
            type: "radio",
            key: "filter-with-active",
            option: [
              { id: "active", value: "Activo" },
              { id: "inactive", value: "Inactivo" },
            ],
            header: {
              title: this.$t("Seleccione un elemento de la lista"),
              signed: this.$t("Puede filtrar la tabla por el estado"),
            },
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  computed: {
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
      this.disablecode = false;
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.MASTER_DATA}/manage-signatures/${rowData.id}`;
        this.disablecode = true;
        this.openAddEditModal();
      }
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    
    deleteData() {
      let url = `${actions.MASTER_DATA}/manage-signatures/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#modal-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.disablecode = true;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

  },
};
</script>
